var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"rgba(139,139,139, 0.03)","border-radius":"10px","position":"absolute","left":"0","bottom":"0","right":"0","top":"0","z-index":"10"}})
}
var staticRenderFns = []

export { render, staticRenderFns }